import { shellMessages } from '@acme/app-shell'
import { createI18n } from 'vue-i18n'
import ptBR from '@/i18n/pt-BR'
import erp from '@/i18n/erp'
import monitoring from '@/i18n/monitoring'
import cnpj from '@/i18n/cnpj'
import campaign from '@/i18n/campaign'
import customerPortal from '@/i18n/customerPortal'

export function createPortalI18n() {
  return createI18n({
    legacy: false,
    locale: 'pt-BR',
    fallbackLocale: 'pt-BR',
    messages: { 'pt-BR': { ...ptBR, erp, monitoring, cnpj, campaign, customerPortal, ...shellMessages['pt-BR'] } },
    datetimeFormats: {
      'pt-BR': {
        short: { day: '2-digit', month: '2-digit', year: 'numeric' },
        long: { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' },
      },
    },
  })
}
